<div [style.width.px]="width" class="card"
     [ngClass]="{'card_le_l': (viewBreakpointService.size$ | async).less('l')}"
>
  <h4>{{ 'term.expiring-terms' | translate }}</h4>

  <p class="title">
    <span>{{ 'unit.expiry-date-tech-inspection' | translate }}:</span>
  </p>

  <p class="align-text">
    <app-expire-icon [date]="inspectionDate"></app-expire-icon>
    {{ (inspectionDate | localDateFormat) || '__.__.____' }}
  </p>

  <p class="title">
    <span>{{ 'unit.expiry-date-insurance' | translate }}:</span>
  </p>
  <p class="align-text">
    <app-expire-icon [date]="insuranceDate"></app-expire-icon>
    {{ (insuranceDate | localDateFormat) || '__.__.____' }}
  </p>

  <p class="title">
    <span>{{ 'unit.expiry-date-speedometer' | translate }}:</span>
  </p>
  <p class="align-text">
    <app-expire-icon [date]="speedometerDate"></app-expire-icon>
    {{ (speedometerDate | localDateFormat) || '__.__.____' }}
  </p>
</div>
